"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_SIZE = 8;
exports.DEFAULT_SCALE = 4;
//# sourceMappingURL=constants.js.map